import { render, staticRenderFns } from "./promo-sales-map.vue?vue&type=template&id=6954fe8b"
import script from "./promo-sales-map.vue?vue&type=script&lang=js"
export * from "./promo-sales-map.vue?vue&type=script&lang=js"
import style0 from "./promo-sales-map.vue?vue&type=style&index=0&id=6954fe8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports